import React from "react";

const BuildingIcon = () => (
    <svg width="40" height="40" viewBox="0 0 40 40" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M15.0588 8.13501H9.45246L7.50024 32H16.8746L15.0588 8.13501Z" fill="#FF2626" />
        <path d="M24.7946 8L17.3491 15.3347L18.6352 31.997H24.7945L24.7946 8Z" fill="#FF2626" />
        <path d="M32.5 8.13501L23.088 17.6212L22.9768 31.9996H32.4999L32.5 8.13501Z" fill="#FF2626" />
    </svg>
);

export default BuildingIcon;